import classNames from "classnames";

import AscHeading from "../../AscTypography/AscHeading/AscHeading";
import AscAdminAction from "../../AscAdminAction/AscAdminAction";
import { MoreIcon } from "../../AscIcons";

import styles from "./AscAuthorCard.module.scss";
import { useOutsideClick } from "@ascendnow/shared";

export interface AscAuthCardProps {
  className?: string;
  imageUrl?: string;
  firstName: string;
  lastName: string;
  bio: string;
  onEdit?: () => void;
  onRemove?: () => void;
}

export default function AscAuthorCard({
  className,
  imageUrl,
  firstName,
  lastName,
  bio,
  onEdit,
  onRemove,
}: AscAuthCardProps) {
  const { ref, isVisible, setIsVisible } =
    useOutsideClick<HTMLDivElement>(false);

  return (
    <div
      data-testid="asc-author-card"
      className={classNames(styles.ground, className)}
    >
      <div className={styles.imageGround}>
        {imageUrl && (
          <img src={imageUrl} alt={imageUrl} className={styles.image} />
        )}
      </div>

      <div className={styles.titleContent}>
        <AscHeading className={styles.title} level={6}>
          {firstName} {lastName}
        </AscHeading>
        <MoreIcon
          className={styles.icon}
          onClick={() => setIsVisible(!isVisible)}
        />

        <div ref={ref}>
          {isVisible && (
            <AscAdminAction
              option1={"Edit"}
              option2={"Remove"}
              clickOption1={onEdit}
              clickOption2={onRemove}
              className={styles.actionBar}
            />
          )}
        </div>
      </div>
      <p
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: bio }}
      ></p>
    </div>
  );
}
